import Vue from 'vue';
import clientTransformer from './../../transformers/client';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const clients = clientTransformer.fetchCollection(data.data);
  resolve(clients);
};

const failed = (error, reject) => reject(error);


export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/reports/clients', params))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/clients.js